'use strict';

import { Tinymce } from "../Components/Tinymce";

export class MyAccountCampaignEdit {
    #form;
    #submitButton;
    #initialFormData;
    #initialImageCount;
    #uploadedFiles;


    constructor() {
        this.#form = document.querySelector('.campaign-details.team-campaign form');
        this.#submitButton = this.#form?.querySelector('.button-update-campaign');

        if (!this.#form || !this.#submitButton) return;

        this.#initialFormData = new FormData(this.#form);
        this.#initialImageCount = this.#getImageCount();
        this.#uploadedFiles = new DataTransfer();

        this.#submitButton.disabled = true;

        this.#addEvents();
        this.#monitorFormChanges();
    }

    #addEvents() {
        const uploadButton = document.querySelector(".additional-image-container .upload-image-button-chaiathon");
        const fileInput = document.getElementById("additional_image");
        const imageContainer = document.querySelector(".additional-images-container");

        if (!uploadButton || !fileInput || !imageContainer) return;

        uploadButton.addEventListener("click", (e) => {
            e.preventDefault();
            // fileInput.click();
        });
        fileInput.addEventListener("change", (event) => {
            const files = event.target.files;

            for (let file of files) {
                this.#uploadedFiles.items.add(file);

                const reader = new FileReader();
                reader.onload = (e) => {
                    const newImageWrapper = document.createElement("div");
                    newImageWrapper.classList.add("image-wrapper");
                    newImageWrapper.style.position = "relative";
                    newImageWrapper.innerHTML = `
                        <img src="${e.target.result}" style="width: 100px; height: 100px; object-fit: cover; margin-right: 10px;">
                        <div class="delete-btn remove-additional-image-button">X</div>
                    `;
                    imageContainer.appendChild(newImageWrapper);
                };
                reader.readAsDataURL(file);
            }

            fileInput.files = this.#uploadedFiles.files;
            this.#checkFormState();
        });

        imageContainer.addEventListener("click", (e) => {
            if (e.target.classList.contains("remove-additional-image-button")) {
                const wrapper = e.target.closest(".image-wrapper");
                wrapper.remove();

                // Remove the file from uploadedFiles (based on index)
                const index = Array.from(imageContainer.querySelectorAll(".image-wrapper")).indexOf(wrapper);
                if (index >= 0) {
                    const newDataTransfer = new DataTransfer();
                    Array.from(this.#uploadedFiles.files).forEach((file, i) => {
                        if (i !== index) newDataTransfer.items.add(file);
                    });
                    this.#uploadedFiles = newDataTransfer;
                    fileInput.files = this.#uploadedFiles.files;
                }

                this.#checkFormState();
            }
        });
    }

    #monitorFormChanges() {
        const inputs = this.#form.querySelectorAll('input, textarea, select');
        inputs.forEach((input) => {
            input.addEventListener('input', () => this.#checkFormState());
            input.addEventListener('change', () => this.#checkFormState());
        });

        if (typeof tinymce !== 'undefined') {
            tinymce.on('AddEditor', (event) => {
                if (event.editor.id === 'campaign_message') {
                    const editor = event.editor;

                    editor.on('change input keyup', () => {
                        editor.save(); // sync TinyMCE content back to textarea
                        this.#checkFormState();
                    });
                }
            });
        }
    }

    #getImageCount() {
        return document.querySelectorAll(".additional-images-container .image-wrapper").length;
    }

    #checkFormState() {
        const requiredFields = this.#form.querySelectorAll('[required]');
        let allFilled = true;

        requiredFields.forEach((field) => {
            if (!field.value.trim()) {
                allFilled = false;
            }
        });

        const currentFormData = new FormData(this.#form);
        let changed = false;

        for (let [key, value] of currentFormData.entries()) {
            const original = this.#initialFormData.get(key) || '';
            if (value !== original) {
                changed = true;
                break;
            }
        }

        // Compare image count
        const currentImageCount = this.#getImageCount();
        if (currentImageCount !== this.#initialImageCount) {
            changed = true;
        }

        this.#submitButton.disabled = !(changed);
    }
}
